import React from 'react';
import { Row, Spinner } from 'react-bootstrap';
import { useLazyLoad } from '../hooks/useLazyLoad';
import { useLanguage } from '../contexts/LanguageContext';
import { t } from '../utils/i18n';

/**
 * Grid with intersection-observer lazy load (same pattern as recommendations).
 */
function WatchedContentListGrid({ items, renderCard }) {
  const { language } = useLanguage();
  const { visibleItems, hasMore, loadingRef } = useLazyLoad(items, 12, 12);

  return (
    <>
      <Row>{visibleItems.map((item) => renderCard(item))}</Row>
      {hasMore ? (
        <div ref={loadingRef} className="text-center py-4">
          <Spinner animation="border" role="status" variant="primary">
            <span className="visually-hidden">{t('common.loading', language)}</span>
          </Spinner>
        </div>
      ) : null}
    </>
  );
}

export default WatchedContentListGrid;
